<script setup>
defineProps({
    // 'vertical' (barres montantes, type colonnes) ou 'horizontal' (barres en lignes)
    variant: { type: String, default: 'horizontal' },
    height: { type: [Number, String], default: 280 },
})

const VERTICAL_BARS = [55, 80, 45, 92, 64, 74, 50, 86, 60, 70, 42, 78]
const HORIZONTAL_BARS = [95, 84, 76, 68, 60, 52, 45, 38]
</script>

<template>
    <div
        v-if="variant === 'vertical'"
        class="d-flex align-items-end gap-2 placeholder-glow"
        :style="{ height: `${height}px` }"
    >
        <span
            v-for="(h, i) in VERTICAL_BARS"
            :key="i"
            class="placeholder rounded-top flex-fill"
            :style="{ height: `${h}%` }"
        ></span>
    </div>
    <div
        v-else
        class="d-flex flex-column gap-3 justify-content-center placeholder-glow"
        :style="{ height: `${height}px` }"
    >
        <span
            v-for="(w, i) in HORIZONTAL_BARS"
            :key="i"
            class="placeholder rounded"
            :style="{ width: `${w}%`, height: '14px' }"
        ></span>
    </div>
</template>
